import { orderRoutes, purchaseOrderRoutes } from '@zen/Routes';

import type { PurchaseOrderTableBannerConfig } from './types';
import { PurchaseOrderTableVersion } from './types';

const bannerConfigs: Record<PurchaseOrderTableVersion, PurchaseOrderTableBannerConfig> = {
  [PurchaseOrderTableVersion.CLASSIC]: {
    actionLabel: 'Use new PO table for more insights',
    icon: 'zicon-information-filled',
    message: 'You are using the Classic PO table.',
    targetUrl: purchaseOrderRoutes.index.getUrl(),
    targetVersion: PurchaseOrderTableVersion.NEW
  },
  [PurchaseOrderTableVersion.NEW]: {
    actionLabel: 'Switch back to Classic',
    icon: 'zicon-sparkles-filled',
    message: 'You are using the new PO table.',
    targetUrl: orderRoutes.index.getUrl(),
    targetVersion: PurchaseOrderTableVersion.CLASSIC
  }
};

export const getBannerConfig = (tableVersion: PurchaseOrderTableVersion): PurchaseOrderTableBannerConfig =>
  bannerConfigs[tableVersion];

export const getPurchaseOrderListUrl = (tableVersion: PurchaseOrderTableVersion): string =>
  tableVersion === PurchaseOrderTableVersion.NEW ? purchaseOrderRoutes.index.getUrl() : orderRoutes.index.getUrl();

export const getPurchaseOrderItemsUrl = (tableVersion: PurchaseOrderTableVersion, purchaseOrderId: string): string =>
  tableVersion === PurchaseOrderTableVersion.NEW
    ? purchaseOrderRoutes.purchaseOrderItems.getUrl(purchaseOrderId)
    : orderRoutes.orderItems.getUrl(purchaseOrderId);
